import React, { Suspense } from 'react';
import { MediaStyles, MediaTemplateProps } from '../';
import { LoadingElement } from '../../';

export const MediaDefaultTemplate = (props: MediaTemplateProps) => {
  const fallback = (
    <LoadingElement
      template="loadingDefault"
      styleClasses={['loadingBase']}
      type="media-default"
      width={props.width}
      height={props.height}
    />
  );

  return (
    <MediaStyles className={props.classes}>
      {props.type === 'image' && (
        <Suspense fallback={fallback}>
          <img src={props.source} width={props.width} height={props.height} />
        </Suspense>
      )}
    </MediaStyles>
  );
};
